import { render, staticRenderFns } from "./offlinePayment.vue?vue&type=template&id=87f90972"
import script from "./offlinePayment.vue?vue&type=script&lang=js"
export * from "./offlinePayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports